import type { LocaleResources } from '../types';

/**
 * Strategy related UI string resources
 * Used in strategy-view, strategy-panel, etc.
 */
export const strategyStr: LocaleResources['strategyStr'] = {
  error: {
    /** Cannot delete strategy in use */
    cannotDeleteInUse: '[{name}] is currently in use and cannot be deleted.',
    /** Cannot delete strategy in use (without name) */
    cannotDeleteInUseSimple: 'Cannot delete strategy that is currently in use.',
    /** Duplicate category name */
    duplicateCategoryName: 'Category name already exists.',
    /** Signal ignore failed */
    ignoreSignalFailed: 'Failed to ignore signal: {error}',
  },
  panel: {
    addSignalType: 'Add Signal Type',
  },
  saveConfirmation: {
    title: 'Unsaved Changes',
    content: 'You have unsaved changes. Do you want to save them?',
    save: 'Save',
    discard: 'Discard',
    cancel: 'Cancel',
  },
  creatorTab: {
    /** Main toolbar strategy name Input placeholder (SubTask 24) */
    namePlaceholder: 'Please enter a strategy name',
    /** Empty-name tooltip on input / save button (SubTask 24) */
    nameRequired: 'Please enter a strategy name',
  },
  filter: {
    strategyName: 'Strategy Name',
    summary: 'Summary',
    selectData: 'Select Data',
    dataLabel: '{label} Data',
  },
  signalType: {
    tab: {
      condition: 'Condition',
      reference: 'Reference',
    },
    header: {
      name: 'Name',
      description: 'Description',
      action: 'Action',
    },
    button: {
      addSignal: '+ Signal',
    },
    popup: {
      selectAction: 'Select Action',
    },
    message: {
      confirmDeleteSignalType: 'Are you sure you want to delete {name} signal type?',
      noSelectedSignalType: 'No signal type selected.',
      confirmDropAction: 'Do you want to {action} [{names}] condition(s) to [{target}]?',
      dropActionSuccess: '[{names}] condition(s) {action}d to [{target}].',
    },
    dialog: {
      addTitle: 'Add Signal Type',
      editTitle: 'Edit Signal Type',
    },
    form: {
      id: 'ID',
      name: 'Name',
      description: 'Description',
    },
    validation: {
      enterName: 'Please enter a name',
    },
  },
  indicator: {
    header: {
      name: 'Name',
      timeframe: 'Timeframe',
      inputs: 'Inputs',
      action: 'Action',
    },
    form: {
      timeframe: 'Timeframe',
      timeframeRequired: 'Please select a timeframe',
    },
    dialog: {
      deleteTimeframeTitle: 'Delete Timeframe',
      deleteTimeframeIndicators: 'The following indicators will be deleted:',
      deleteTimeframeConditions: 'The following conditions will also be deleted:',
    },
  },
  condition: {
    header: {
      name: 'Name',
      group: 'Group',
      timeframe: 'TF',
      operand1: 'Item',
      operator: 'Condition',
      operand2: 'Compare Item',
      options: 'Options',
      action: 'Action',
    },
    button: {
      changeTimeframe: 'Change TF',
      changeOperator: 'Change Cond',
      enableCondition: 'Enable',
      disableCondition: 'Disable',
    },
    offset: {
      byCandle: 'Use Candle Offset',
      byValue: 'Use Value Offset',
    },
    tooltip: {
      dragToOtherSignalType: 'Drag to copy/move/share to other signal type',
    },
    options: {
      consecutiveMin: '{min}+ consecutive',
      consecutiveMax: '~ {max} consecutive max',
    },
    message: {
      noSelectedCondition: 'No condition selected.',
    },
    form: {
      symbol: 'Symbol',
      symbolPlaceholder: 'e.g., BTC/USDT:USDT (applies to this symbol only)',
      symbolTooltip: 'Conditions using shapes or webhook are specific to a particular symbol',
      optional: '(Optional)',
    },
    operand: {
      shapeIdFormat: '(id{id})',
    },
  },
  reference: {
    header: {
      baseAsset: 'Base Asset',
      targetTrend: 'Target Trend',
      currentTrend: 'Current',
    },
    title: 'Trend Reference Asset List',
    button: {
      addReference: '+ Reference',
    },
  },
  editMode: {
    add: 'Add: {count}',
    edit: 'Edit: {count}',
    delete: 'Delete: {count}',
  },
  label: {
    selected: 'Selected',
  },
};
